import DefaultLayout from "../components/layout/DefaultLayout";
import FormBlocContainer from "../components/layout/form/FormBlocContainer";


const ProtectionDonneesPage = () => {

    return <DefaultLayout>
        <FormBlocContainer title="Protection des données à caractère personnel">

            <p>Conformément à la loi Informatique et Libertés n°78-17 du 6 janvier 1978 modifiée et au Règlement Général
                sur la Protection des Données à caractère personnel (ci-après « RGPD ») n° 2016/679/UE du 27 avril 2016,
                Uniprevoyance FRANCE, en qualité de responsable de traitement, garantit l’intégrité et la sécurité des
                données personnelles des Utilisateurs du site Internet Uniprevoyance.fr et des services associés dont
                notamment l’Espace Personnel (ci-après dénommé le Site).</p>

            <p>L'Utilisateur, personne physique, est informé que les informations qu’il communique par le biais du Site,
                dont les bases légales des traitements associés sont soit l’exécution de mesures précontractuelles ou
                contractuelle, soit l’intérêt légitime poursuivi par Uniprevoyance FRANCE afin de pouvoir répondre à vos
                demandes, ainsi que des obligations légales, sont destinées aux services habilités de Uniprevoyance
                FRANCE, le cas échéant les partenaires, sous-traitants et tiers autorisés, à des fins de gestion des
                relations clients et prospects, de lutte contre le blanchiment des capitaux et le financement du
                terrorisme, de gestion des risques opérationnels dont la fraude à l'assurance.</p>

            <p>Pendant la consultation du Site et l’accès aux services en ligne, l’Utilisateur peut être sollicité pour
                communiquer volontairement certaines données personnelles (nom, prénom, courriel, email, numéro de
                téléphone, identifiants, ...). Les formulaires de collecte présents sur le Site précisent notamment la
                finalité, les destinataires, la durée de conservation et le caractère obligatoire ou facultatif des
                données demandées par un astérisque.</p>

            <p>Les données personnelles collectées et traitées sur le Site sont protégées par des mesures techniques et
                organisationnelles appropriées afin de garantir un niveau de sécurité adapté au risque.</p>

            <p>L'Utilisateur du Site est informé qu'il dispose d'un droit d'accès, de rectification, de suppression, de
                limitation, de portabilité (lorsqu’il s’applique) et d’opposition sur les données le concernant.
                L’Utilisateur peut exercer ces droits en s’adressant au service DPO d'Uniprevoyance FRANCE à l’adresse
                dpo@uniprevoyance.fr.</p>

            <p>Par ailleurs, chaque e-mail envoyé par Uniprevoyance FRANCE vous indique comment ne plus le recevoir.</p>

            <p>L’Utilisateur dispose également du droit d’introduire une réclamation auprès de la CNIL.</p>

            <p>Les Utilisateurs du Site sont tenus de respecter les dispositions de la loi Informatique et Libertés et
                du RGPD, notamment en s'abstenant de toute collecte ou utilisation détournée des données à caractère
                personnel auxquelles ils accèdent.</p>
            
        </FormBlocContainer>
    </DefaultLayout>
}

export default ProtectionDonneesPage;